
import {
  defineComponent,
  computed,
  ref,
  onMounted,
} from 'vue';

import DataExplorerLink from '@/components/data-explorer/fields/DataExplorerLink.vue';
import ProductItem from '@/components/data-explorer/fields/ProductItem.vue';
import List from '@/components/data-explorer/fields/List.vue';

import {
  getCartProducts,
} from '@/composables/data-explorer/DataExplorer';

import { fetchDataSources } from '@/composables/segmentations/helpers/fetchData';

import { formatDate } from '@/helpers/Date';
import { formatNumberToCurrency } from '@/helpers/Number';

import { DataExplorerDataType } from '@/types';

import { CartProduct } from '@/types/data-explorer-types';

import { useStore } from '@/store';

import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'CartFile',

  components: {
    DataExplorerLink,
    List,
    ProductItem,
  },

  setup() {
    const { t, locale } = useI18n();
    const store = useStore();

    const selectedData = computed(() => store.getters['dataExplorer/getSelectedData']);

    // Source label
    const sourceLabel = ref('');
    onMounted(async () => {
      if (!selectedData.value?.dataSourceId) return;
      const sources = await fetchDataSources();
      const found = sources.find((s: any) => s.value === Number(selectedData.value.dataSourceId));
      if (found) sourceLabel.value = found.shortLabel || found.label;
    });

    const title = computed(() => {
      if (selectedData.value) {
        return t(`dataExplorer.tabs.${selectedData.value.dataType}`, [selectedData.value.idCart]);
      }
      return '';
    });

    const isCartValid = computed(() => selectedData.value.isValid && selectedData.value.isValid !== '0');

    const dataExplorerType = ref(DataExplorerDataType);

    const handleRetrieveProducts = (cartProducts: CartProduct[]) => {
      store.dispatch(
        'dataExplorer/setAdditionnalData',
        {
          dataId: selectedData.value.dataId,
          newLists: cartProducts,
          dataKey: 'products',
        },
      );
    };

    return {
      t,
      locale,
      title,
      selectedData,
      sourceLabel,
      isCartValid,
      dataExplorerType,

      formatDate,
      formatNumberToCurrency,
      getCartProducts,
      handleRetrieveProducts,
    };
  },
});
